import React from 'react';
import './Cartesocial.css';
import sos1 from '../../Images/Socialgalerie/sos1.jpg';
import sos2 from '../../Images/Socialgalerie/sos2.jpg';
import sos3 from '../../Images/Socialgalerie/sos3.jpg';
import sos4 from '../../Images/Socialgalerie/sos4.jpg';
import sos5 from '../../Images/Socialgalerie/sos5.jpg';
import sos6 from '../../Images/Socialgalerie/sos6.jpg';
import sos7 from '../../Images/Socialgalerie/sos7.jpg';
import sos8 from '../../Images/Socialgalerie/sos8.jpg';
import sos9 from '../../Images/Socialgalerie/sos09.jpg';
import sos10 from '../../Images/Socialgalerie/sos10.jpg';
import sos11 from '../../Images/Socialgalerie/sos11.jpg';
import sos12 from '../../Images/Socialgalerie/sos12.jpg';
import sos13 from '../../Images/Socialgalerie/sos13.jpg';

const Cartesocial = () => {
    return (
        <div className="Cartephotos-social">
            <div className='container-social'>
                <div className='barre-social'>
                    <div className='traitssocial'></div>
                    <div className='trait24ssocial'></div>
                </div>
            </div>

            <div className="cards1-containersocial">
                <div className="sos0">
                    <img src={sos10} alt="" />
                </div>

                <div className="sos1">
                    <img src={sos1} alt="" />
                </div>

                <div className="sos2">
                    <img src={sos2} alt="" />
                </div>

                <div className="sos3">
                    <img src={sos3} alt="" />
                </div>

                <div className="sos4">
                    <img src={sos4} alt="" />
                </div>

                <div className="sos5">
                    <img src={sos5} alt="" />
                </div>

                <div className="sos6">
                    <img src={sos6} alt="" />
                </div>
                 
                <div className="sos7">
                    <img src={sos7} alt="" />
                </div>

                <div className="sos8">
                    <img src={sos8} alt="" />
                </div>
                
                <div className="sos9">
                    <img src={sos9} alt="" />
                </div>
                 
                <div className="sos10">
                    <img src={sos10} alt="" />
                </div>
                  
                <div className="sos11">
                    <img src={sos11} alt="" />
                </div>
                   
                <div className="card11">
                    <img src={sos12} alt="" />
                </div>
                     
                <div className="sos13">
                    <img src={sos13} alt="" />
                </div>  

                <div className="sos12">
                    <img src={sos5} alt="" />
                </div>
            </div>
        </div>
    );
};

export default Cartesocial;
 